import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import otp from "./modules/otp";
import avConnection from "./modules/avConnection";
import ably from "./modules/ably";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    otp,
    avConnection,
    ably,
  },
});
